import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { recommendationToUserHistoryData } from '__mocks__/mockData/recommendation-to-user-history-data';

const RecommendationToUserHistoryApi = [
  rest.get(`${API_ROOT}recommendation-to-user/:patientId/history`, (req, res, ctx) => res(ctx.json(recommendationToUserHistoryData))),
];
export default RecommendationToUserHistoryApi;
